import { useEffect, useState } from "react";
import { Col, Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";

const MoleculeInputNumber = ({ label, tooltip, value, onChange, min = 0, disable = false }) => {
    const uniqueId = uuidv4();
    const [tempValue, setTempValue] = useState(0);
    useEffect(() => {
        setTempValue(value ?? min);
    }, [value])
    return (
        <Col className="text-start">

            <InputGroup className="mt-2 align-items-center">
                {/* Icon Info với Tooltip */}
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{tooltip}</Tooltip>}
                >
                    <InfoCircle className="me-1 mb-1 text-primary" style={{ cursor: "pointer", fontSize: "16px", minWidth: "16px" }} />
                </OverlayTrigger>
                <InputGroup.Text id={`inputGroup-${uniqueId}`}>{label}</InputGroup.Text>
                <Form.Control
                    disabled={disable}
                    aria-describedby={`inputGroup-${uniqueId}`}
                    type="text"
                    inputMode="numeric"
                    min={min}
                    value={tempValue}
                    onChange={(e) => {
                        let newValue = e.target.value.replace(/[^0-9]/g, ""); // Chỉ cho phép nhập số
                        if (newValue === "") newValue = 0
                        setTempValue(Number(newValue))
                    }}
                    onBlur={(e) => {
                        let newValue = e.target.value.replace(/[^0-9]/g, ""); // Chỉ cho phép nhập số
                        if (newValue === "" || newValue < min) newValue = min
                        onChange(newValue);
                    }}
                />
            </InputGroup>
        </Col>
    );
};
export default MoleculeInputNumber